{
  "version": "1.2.6",
  "objects": {
    "7431911322594381484": {
      "type": "frame",
      "id": "7431911322594381484",
      "z": 7066,
      "textContent": "",
      "left": 889.8800723814388,
      "top": 333.3443205645799,
      "width": 400,
      "height": 500,
      "scaleX": 1.282870236650997,
      "scaleY": 0.6940333076064749,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7431911322593624867": {
      "type": "frame",
      "id": "7431911322593624867",
      "z": 4319,
      "textContent": "Frame 14",
      "left": 909.8800723814388,
      "top": 353.3443205645799,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.102,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911322594381484",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0z",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911322592522937": {
      "type": "shape",
      "id": "7431911322592522937",
      "z": 4320,
      "shapeName": "icon",
      "textContent": "",
      "left": 1367.9013660275616,
      "top": 368.3428797531591,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13126801014276016,
      "scaleY": 0.13126801014276016,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7431911322593624867",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    },
    "7431911322597852856": {
      "type": "frame",
      "id": "7431911322597852856",
      "z": 4323,
      "textContent": "Frame 14",
      "left": 909.8800723814388,
      "top": 353.3443205645799,
      "width": 400,
      "height": 500,
      "scaleX": 0.2144965950791726,
      "scaleY": 0.102,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911322593624867",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911322597802909": {
      "type": "shape",
      "id": "7431911322597802909",
      "z": 4324,
      "shapeName": "icon",
      "textContent": "",
      "left": 909.8800723814388,
      "top": 366.9450015487454,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.23798638031669025,
      "scaleY": 0.23798638031669025,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#F9C61F",
      "angle": 0,
      "container": "7431911322597852856",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "Zyzz",
      "maskType": "none",
      "iconName": "fas/circle-exclamation",
      "locked": false
    },
    "7431911322602793222": {
      "type": "shape",
      "id": "7431911322602793222",
      "z": 4327,
      "shapeName": "text",
      "textContent": "<p>Title</p>",
      "left": 933.6787104131079,
      "top": 353.3443205645799,
      "width": 36.16666666666667,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7431911322597852856",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "locked": false
    },
    "7431911322595981164": {
      "type": "frame",
      "id": "7431911322595981164",
      "z": 6948,
      "textContent": "Frame 20",
      "left": 909.8800723814388,
      "top": 621.3443205645799,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.07971875,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911322594381484",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7431911322600570001": {
      "type": "wireframe",
      "id": "7431911322600570001",
      "z": 6976,
      "top": 621.8443205645799,
      "left": 909.8800723814388,
      "width": 59.79296875,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911322595981164",
      "layoutPosition": "a0",
      "wireframeName": "button",
      "fill": "#B6B6B6",
      "textColor": null,
      "style": "square",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Close" }
    },
    "7431911322588667769": {
      "type": "wireframe",
      "id": "7431911322588667769",
      "z": 7006,
      "top": 621.8443205645799,
      "left": 1308.0213311043376,
      "width": 73.0068359375,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911322595981164",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#F9C61F",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Confirm" }
    },
    "7431911322599737153": {
      "type": "shape",
      "id": "7431911322599737153",
      "z": 6996,
      "shapeName": "text",
      "textContent": "<p>Paragraph text</p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p>",
      "left": 909.8800723814388,
      "top": 424.3443205645799,
      "width": 545.4922019496454,
      "height": 205.43004201082388,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7431911322594381484",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
